module.exports = __webpack_public_path__ + "img/GezeitenDerDialoge.939f6ad3.jpg";